import {
  JACKPOT_SYMBOL,
  REEL_COUNT,
  SLOT_SYMBOLS,
  SpinOutcome,
  SlotSymbol,
  SYMBOL_HEIGHT_PX,
} from "./types";

export function pickRandomSymbol(): SlotSymbol {
  return SLOT_SYMBOLS[Math.floor(Math.random() * SLOT_SYMBOLS.length)];
}

export function generateSpinResult(): SlotSymbol[] {
  return Array.from({ length: REEL_COUNT }, () => pickRandomSymbol());
}

export function evaluateSpin(result: SlotSymbol[]): SpinOutcome {
  const [a, b, c] = result;
  const allMatch = a === b && b === c;

  if (!allMatch) {
    return {
      result,
      isWin: false,
      isJackpot: false,
      winningSymbol: null,
    };
  }

  const isJackpot = a === JACKPOT_SYMBOL;

  return {
    result,
    isWin: true,
    isJackpot,
    winningSymbol: a,
  };
}

/** Builds a vertical symbol strip ending on `target` for reel animation */
export function buildReelStrip(target: SlotSymbol, cycles = 18): SlotSymbol[] {
  const strip: SlotSymbol[] = [];
  for (let i = 0; i < cycles; i++) {
    strip.push(...SLOT_SYMBOLS);
  }
  strip.push(target);
  return strip;
}

export function getStripStopOffset(strip: SlotSymbol[]): number {
  const targetIndex = strip.length - 1;
  return -(targetIndex * SYMBOL_HEIGHT_PX);
}
